import {InputBase, withStyles} from '@material-ui/core';
import {APP_PRIMARY_COLOR, GET_8_PIXEL_BOX} from '../../../style/variable';
const StyledSelectInput = withStyles({
  root: {
    borderRadius: `${GET_8_PIXEL_BOX(0.5)}`,
    height: 'auto',
    overflow: 'auto'
  },
  input: {
    padding: '12px 32px 12px 12px',
    color: APP_PRIMARY_COLOR,
    borderRadius: '8px',
    display: 'inline-block',
    width: '100%',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis',
    '& .MuiListItemText-primary': {
      fontSize: '1.2rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      marginTop: '5px',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  }
})(InputBase);

export default StyledSelectInput;
